import { ExchangeRate } from '@/types/exchangeRate';

export function xmlToJson(xml: string): ExchangeRate {
	const parser = new DOMParser();
	const docNode = parser.parseFromString(xml, 'text/xml');

	function parseNode(node: Element | null) {
		const jsonObj: Record<string, unknown> = {};
		if (!node) {
			return jsonObj;
		}
		if (node.attributes && node.attributes.length > 0) {
			Array.from(node.attributes).forEach((attribute) => {
				jsonObj[attribute.nodeName] = ['Buy', 'Sale', 'Change', 'Middle'].includes(
					attribute.nodeName
				)
					? Number(attribute.nodeValue)
					: attribute.nodeValue;
			});
		}
		if (node.childNodes && node.childNodes.length > 0) {
			node.childNodes.forEach((childNode) => {
				if (childNode.nodeType !== 3) {
					if (typeof jsonObj[childNode.nodeName] === 'undefined') {
						jsonObj[childNode.nodeName] = [];
					}

					const list = jsonObj[childNode.nodeName];

					if (Array.isArray(list)) {
						list.push(parseNode(childNode as Element));
					}
				}
			});
		}
		return jsonObj;
	}

	return { ExchangeRate: parseNode(docNode.firstChild as Element | null) } as ExchangeRate;
}
